<template>
  <IQOS 
    :title="$t('integrations.poster_instant_ui.title')"
    :class="{
        'iqos-transparent': !isActive
    }" 
    :readonly="false">
    <p class="comment c-gray pt-0">
        {{
            $t('integrations.poster_instant_ui.desc')
        }}
    </p>
    <IQOSTogle v-model="isActive"/>
  </IQOS>
</template>

<script>
import IQOS from '@/components/IQOS.vue'
import IQOSActions from '@/components/IQOSActions.vue'
import BlackInput from '@/components/BlackInput.vue'
import IQOSTogle from "@/components/IQOSToggle.vue"

export default {    
    components: {
        IQOS,
        IQOSActions,
        IQOSTogle
    },
    data() {
        return {
        }
    },
    methods: {
        
    },
    mounted() {
        
    },
    computed: {
        isActive: {
            get() {
                return this.$store.state.cafe.poster.instant_orders_ui;
            },
            set(v) {
                this.$store.commit('setPosterSetting', {
                    key: 'instant_orders_ui',
                    value: v
                });
                this.$store.dispatch('saveCafe');
            }
        }
    }
}
</script>

<style>

</style>